// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export class DataState<T = void> {} // eslint-disable-line @typescript-eslint/no-unused-vars
// This, line above, requires too many exceptions to be used. Is not there a better way?

export class InitialState extends DataState<unknown> {}

export class Loading extends DataState<unknown> {
  message?: string;

  constructor(message = "") {
    super();
    this.message = message;
  }
}

export class LoadingFailed extends DataState<unknown> {
  message: string;
  source: string;

  constructor(message: string, source: string) {
    super();
    this.message = message;
    this.source = source;
  }
}

export class LoadingSucceeded<T> extends DataState<T> {
  data?: T;
  message?: string;

  constructor({ data, message }: { data?: T; message?: string } = {}) {
    super();
    this.data = data;
    this.message = message;
  }
}

export const getValueFromState = <T>({ state }: { state?: DataState<T> }): T | undefined => {
  if (state instanceof LoadingSucceeded) {
    return state.data;
  }
  return undefined;
};
